import { useMutation, useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IVehiclePackageResponse } from "../models/VehiclePackageData";
import apiConfig from "../utils/apiConfig";


export default function useVehiclePackageData(vehicleId: string, componentName = "useVehiclePackageData") {
  const { get, post } = useApiHelper(apiConfig(componentName));
  const staleTime = 1000 * 60 * 10; //10 minutes

  const vehiclePackageData = useQuery<IVehiclePackageResponse>({
    queryKey: ["vehiclePackage", vehicleId],
    queryFn: () =>
      get<IVehiclePackageResponse>(
        `/vehicle/package/${vehicleId}`
      ),
    staleTime: staleTime,
    enabled: !!vehicleId,
  });

  const getVehiclePackageData = useMutation({
    mutationFn: (data: any) =>
      post<IVehiclePackageResponse>(
        `/vehicle/package/add`,
        data
      ),
  });

  return {
    vehiclePackageData,
    getVehiclePackageData,
  };
}